export default [
    {
        path: '/bin/create-bins',
        name: 'bin_create_bins',
        component: () => import('@src/bin/create-bins.vue'),
        meta: {
            title: 'Lagerfächer anlegen',
            role: 'ROLE_CREATE_BIN',
        },
    },
];
